import React, { useRef, useState, useEffect } from "react";
import JsBarcode from "jsbarcode";
import { jsPDF } from "jspdf";
import { useContextApi } from "../../../context/ContextApi";
import InterRegular from "../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../sale/font/Inter_24pt-Bold-normal";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import autoTable from "jspdf-autotable";
import { usePermission } from "../../../context/PermissionContext";
import { useAuth } from "../../../context/AuthProvider";
import axios from "axios";
import handleError from "../../../constants/handleError";
import { useShowAlert } from "../../../context/AlertContext";
import CopyBarcodeText from "./CopyBarcode";
import { PrinterIcon } from "../../../constants/Icons";

const BarcodeGenerator = ({
  barcodeValue: initialBarcode = "",
  onClose,
  product,
}) => {
  const canvasRef = useRef(null);
  const canvasRefs = useRef([]);
  const [barcodeValue] = useState(initialBarcode);
  const [printCount, setPrintCount] = useState(1);
  const [error, setError] = useState("");
  const { useEscapeKey } = useContextApi();
  const { settings } = useAuth();
  const showAlert = useShowAlert();
  const [selectedSize, setSelectedSize] = useState(
    "2LABEL"
  );
  const [showMrp,setShowMrp]=useState(true);
  const [toggle, setToggle] = useState(true);
  const [loading,setLoading]= useState(false)

  const barcodeWidth = 1;
  const barcodeHeight = 40;

  const sizeOptions = [
    { key: "2LABEL", label: "2 - 50x25mm Label" },
    { key: "3LABEL", label: "2 - 38x25mm Label" },
    { key: "4LABEL", label: "4 - 25x20mm Label" },
  ];

 
  useEffect(() => {
    if (!barcodeValue) return;
  
    const labelCount = selectedSize === "2LABEL" ? 2 : selectedSize === "3LABEL" ? 2 :4;
  
    canvasRefs.current = canvasRefs.current.slice(0, labelCount);
  
    canvasRefs.current.forEach((canvas) => {
      if (!canvas) return;
  
      const ctx = canvas.getContext("2d");
  
      //  CLEAR OLD BARCODE
      ctx.clearRect(0, 0, canvas.width, canvas.height);
  
      const scale = 4;
      //  FORCE CANVAS SIZE
      const baseWidth = (selectedSize === "2LABEL" || selectedSize === "3LABEL") ? 180 : 90;
      const baseHeight = 60;

      canvas.width = baseWidth * scale;
    canvas.height = baseHeight * scale;

    ctx.scale(scale, scale);
  
      JsBarcode(canvas, barcodeValue, {
        format: "CODE128",
        width: (selectedSize === "2LABEL") ? 3 : 2, // 👈 IMPORTANT
        height: 40,
        displayValue: false,
        margin: 0,
        background: "#ffffff",
        lineColor: "#000000",
      });
    });
  }, [barcodeValue, selectedSize]);

  
  // useEffect(() => {
  //   if (!barcodeValue) {
  //     setError("Please enter a barcode value.");
  //     return;
  //   }

  //   canvasRefs.current.forEach((canvas) => {
  //     if (!canvas) return;
    
  //     JsBarcode(canvas, barcodeValue, {
  //       width: 1,
  //       height: barcodeHeight,
  //       displayValue: false,
  //       margin: 0
  //     });
  //   });

  //   if (canvasRef.current) {
  //     setError("");
  //     JsBarcode(canvasRef.current, barcodeValue, {
  //       format: "CODE128",
  //       width: 1,
  //       height: 40,
  //       displayValue: false,
  //       margin: 0,
  //     });
  //   }
  // }, [barcodeValue]);

  const ellipsize = (doc, text, maxWidth) => {
    if (!text) return [];
  
    // Split text into lines based on width
    const lines = doc.splitTextToSize(text, maxWidth);
  
    // If it fits in 2 lines, return as-is
    if (lines.length <= 2) {
      return lines;
    }
  
    // Ellipsize ONLY the second line
    let secondLine = lines[1];
  
    while (secondLine.length > 0) {
      secondLine = secondLine.slice(0, -1);
      if (doc.getTextWidth(secondLine + "...") <= maxWidth) {
        break;
      }
    }
  
    return [lines[0], secondLine + "..."];
  };
  
// electron appliction trigger api 
//   const handlePrintService=async(pdfBase64,printerName)=>{
//     try{
//      const response=await axios.post('http://127.0.0.1:9164/print/pdf',{
//       pdfBase64,
//       printerName
//      },{
//       headers: {
//         'Content-Type': 'application/json'
//       }
//     }
// )
//     }catch(error){
//       handleError(error,showAlert);
//     }
//   }
// old print code
  const handlePrintPDF = () => {
    if (!barcodeValue) {
      setError("Please enter a barcode value before printing.");
      return;
    }

    const canvas = canvasRef.current;
    const imageData = canvas.toDataURL("image/png");

    const doc = new jsPDF({
      unit: "pt",
      format: [288, 1000],
      orientation: "portrait",
    });

    const mrp = Number(CurrencyConverter.toCurrency(product?.mrp, "INR") || 0);
    const salePrice = Number(
      CurrencyConverter.toCurrency(product?.saleprice, "INR") || 0
    );

    /** Build rows (2 columns per row) */
    const rows = [];
    for (let i = 0; i < Number(printCount); i += 2) {
      rows.push(["", ""]);
    }

    autoTable(doc, {
      startY: 0,
      margin: { top: 0, left: 0, right: 0, bottom: 0 }, // ✅ ZERO margin
      theme: "grid",
      tableWidth: doc.internal.pageSize.getWidth(),
      styles: {
        minCellHeight: 71,
        cellPadding: 0,
      },
      columnStyles: {
        0: { cellWidth: doc.internal.pageSize.getWidth() / 2 },
        1: { cellWidth: doc.internal.pageSize.getWidth() / 2 },
      },
      body: rows,

      didDrawCell: (data) => {
        if (data.section !== "body") return;

        data.row.height = 71;

        const cellIndex = data.row.index * 2 + data.column.index;
        if (cellIndex >= Number(printCount)) return;

        const { x, y, width } = data.cell;

        const paddingX = 10; // ✅ SAFE padding
        let cursorY = y + 10;
        const centerX = x + width / 2;

        /** Title */
        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(11);
        doc.text(product?.title || "", centerX, cursorY + 5, {
          align: "right",
          maxWidth: width - paddingX * 2,
        });

        cursorY += 10;

        /** Barcode (perfectly centered) */
        const barcodeWidth = width - 30 * 2;
        const barcodeHeight = 18;
        const barcodeX = centerX - barcodeWidth / 2;

        doc.addImage(
          imageData,
          "PNG",
          barcodeX,
          cursorY,
          barcodeWidth,
          barcodeHeight
        );

        cursorY += barcodeHeight + 12;

        /** Pricing */
        doc.setFontSize(11);

        if (mrp > salePrice) {
          doc.setFont("Inter-Regular", "normal");
          doc.text("MRP:", x + paddingX + 20, cursorY);

          const labelW = doc.getTextWidth("MRP:");
          const valueX = x + paddingX + 20 + labelW + 4;

          const mrpText = `₹ ${mrp}`;
          doc.text(mrpText, valueX, cursorY);

          const textW = doc.getTextWidth(mrpText);

          doc.setDrawColor(0, 0, 0);
          doc.setLineWidth(1); // thermal friendly
          doc.line(valueX, cursorY - 3, valueX + textW, cursorY - 3);

          cursorY += 10;
        }

        doc.setFont("Inter-Regular", "normal");
        doc.text("Rate:", x + paddingX + 20, cursorY);

        const spLabelW = doc.getTextWidth("Rate:");
        doc.setFont("Inter-Bold", "bold");
        doc.text(`₹ ${salePrice}`, x + paddingX + 20 + spLabelW + 4, cursorY);
      },
    });

    return doc;
  };
//side gap and hight added print not recommended
  // const handlePrintPDF2V1 = () => {
  //   if (!barcodeValue) {
  //     setError("Please enter a barcode value before printing.");
  //     return;
  //   }

  //   const canvas = canvasRef.current;
  //   const imageData = canvas.toDataURL("image/png");

  //   const salePrice = Number(
  //     CurrencyConverter.toCurrency(product?.saleprice, "INR") || 0
  //   );
  //   const mrp = Number(CurrencyConverter.toCurrency(product?.mrp, "INR") || 0);

  //   const storeName = settings?.saleProfileData?.title || "";

  //   /* PAGE & LABEL CONFIG */
  //   const PAGE_WIDTH = 101.6;
  //   const PAGE_HEIGHT = 112;
  //   const COLS = 2;
  //   const ROW_HEIGHT = 15.3;
  //   const ROW_GAP = 12;
  //   const TOP_GAP = 10;
  //   const SIDE_GAP = 2;
  //   const COLUMN_GAP = 2; // ✅ NEW

  //   const LABEL_WIDTH = (PAGE_WIDTH - SIDE_GAP * 2 - COLUMN_GAP) / COLS;

  //   const doc = new jsPDF({
  //     unit: "mm",
  //     format: [PAGE_WIDTH, PAGE_HEIGHT],
  //     orientation: "portrait",
  //   });

  //   /* CONTENT HEIGHTS */
  //   const TITLE_H = 4;
  //   const BARCODE_H = 6;
  //   const GAP1 = 0.8;
  //   const PRICE_LINE_H = 3;
  //   const STORE_H = 3;
  //   const CONTENT_HEIGHT = TITLE_H + BARCODE_H + GAP1 + PRICE_LINE_H + STORE_H;

  //   let currentY = TOP_GAP;

  //   for (let i = 0; i < Number(printCount); i++) {
  //     const col = i % COLS;

  //     if (col === 0 && i !== 0) {
  //       currentY += ROW_HEIGHT + ROW_GAP;

  //       if (currentY + CONTENT_HEIGHT > PAGE_HEIGHT) {
  //         doc.addPage([PAGE_WIDTH, PAGE_HEIGHT]);
  //         currentY = TOP_GAP;
  //       }
  //     }

  //     const RIGHT_COL_EXTRA_PADDING = (SIDE_GAP*2);
  //     const rowX = SIDE_GAP + col * (LABEL_WIDTH + COLUMN_GAP)+(col === 1 ? RIGHT_COL_EXTRA_PADDING : 0);
  //     const y = currentY + (ROW_HEIGHT - CONTENT_HEIGHT) / 2;

  //     /* TITLE */
  //     doc.setFont("Inter-Bold", "bold");
  //     doc.setFontSize(8);
  //     const title = ellipsize(doc, product?.title || "", LABEL_WIDTH - 3);
  //     doc.text(
  //       title,
  //       rowX + (LABEL_WIDTH - doc.getTextWidth(title)) / 2,
  //       y + TITLE_H - 1
  //     );

  //     /* BARCODE */
  //     const barcodeY = y + TITLE_H;
  //     const barcodeWidth = LABEL_WIDTH - 20;
  //     doc.addImage(
  //       imageData,
  //       "PNG",
  //       rowX + (LABEL_WIDTH - barcodeWidth) / 2,
  //       barcodeY,
  //       barcodeWidth,
  //       BARCODE_H
  //     );

  //     /* PRICE LINE */
  //     const priceY = barcodeY + BARCODE_H + GAP1;
  //     const rateText = `Rate: ₹ ${salePrice}`;
  //     const mrpText = mrp && mrp !== salePrice ? `MRP: ₹ ${mrp}` : "";

  //     let combinedWidth = mrpText
  //       ? doc.getTextWidth(mrpText) + 2 + doc.getTextWidth(rateText)
  //       : doc.getTextWidth(rateText);

  //     let priceX = rowX + (LABEL_WIDTH - combinedWidth) / 2;

  //     if (mrpText) {
  //       doc.setFont("Inter-Regular", "normal");
  //       doc.setFontSize(6);
  //       doc.text(mrpText, priceX, priceY + 2);

  //       const w = doc.getTextWidth(mrpText);
  //       doc.line(priceX, priceY + 1.5, priceX + w, priceY + 1.7);
  //       priceX += w + 2;
  //     }

  //     doc.setFont("Inter-Bold", "bold");
  //     doc.setFontSize(8);
  //     doc.text(rateText, priceX, priceY + 2);

  //     /* STORE NAME */
  //     if (storeName) {
  //       doc.setFont("Inter-Regular", "normal");
  //       doc.setFontSize(4);
  //       const storeText = ellipsize(doc, storeName, LABEL_WIDTH - 3);
  //       doc.text(storeText, rowX + 1.5, priceY + PRICE_LINE_H + 3);
  //     }
  //   }

  //   return doc;
  // };

// final crted align code full a4 recommened but improved require for waste page's
  // const handlePrintPDF2V2 = () => {
  //   if (!barcodeValue) {
  //     setError("Please enter a barcode value before printing.");
  //     return;
  //   }
  
  //   const canvas = canvasRef.current;
  //   const imageData = canvas.toDataURL("image/png");
  
  //   const salePrice = Number(
  //     CurrencyConverter.toCurrency(product?.saleprice, "INR") || 0
  //   );
  //   const mrp = Number(
  //     CurrencyConverter.toCurrency(product?.mrp, "INR") || 0
  //   );
  
  //   const storeName = settings?.saleProfileData?.title || "";
  
  //   /* ================= PAGE & PRINTER CONFIG ================= */
  
  //   const PAGE_WIDTH = 101.6;        // 4 inch paper
  //   const PAGE_HEIGHT = 112;
  
  //   const PRINTER_RIGHT_DEADZONE = 3; // ✅ REAL printer limitation (from photo)
  //   const EFFECTIVE_PAGE_WIDTH = PAGE_WIDTH - PRINTER_RIGHT_DEADZONE;
  
  //   const COLS = 2;
  //   const SIDE_GAP = 1;
  //   const COLUMN_GAP = 2;
  
  //   const LABEL_WIDTH =
  //     (EFFECTIVE_PAGE_WIDTH - SIDE_GAP * 2 - COLUMN_GAP) / COLS;
  
  //   const ROW_HEIGHT = 15.3;
  //   const ROW_GAP = 12;
  //   const TOP_GAP = 10;
  
  //   const doc = new jsPDF({
  //     unit: "mm",
  //     format: [PAGE_WIDTH, PAGE_HEIGHT],
  //     orientation: "landscape",
  //   });
  
  //   /* ================= CONTENT HEIGHTS ================= */
  
  //   const TITLE_H = 4;
  //   const BARCODE_H = 6;
  //   const GAP1 = 0.8;
  //   const PRICE_LINE_H = 3;
  //   const STORE_H = 3;
  
  //   const CONTENT_HEIGHT =
  //     TITLE_H + BARCODE_H + GAP1 + PRICE_LINE_H + STORE_H;
  
  //   let currentY = TOP_GAP;
  
  //   /* ================= PRINT LOOP ================= */
  
  //   for (let i = 0; i < Number(printCount); i++) {
  //     const col = i % COLS;
  
  //     if (col === 0 && i !== 0) {
  //       currentY += ROW_HEIGHT + ROW_GAP;
  
  //       if (currentY + CONTENT_HEIGHT > PAGE_HEIGHT) {
  //         doc.addPage([PAGE_WIDTH, PAGE_HEIGHT]);
  //         currentY = TOP_GAP;
  //       }
  //     }
  
  //     const RIGHT_COL_EXTRA_PADDING = (SIDE_GAP*2)+1.6;
  //     const rowX =
  //       SIDE_GAP-1 + col * (LABEL_WIDTH + COLUMN_GAP)+(col === 1 ? RIGHT_COL_EXTRA_PADDING+1 : 0);
  
  //     const y =
  //       currentY + (ROW_HEIGHT - CONTENT_HEIGHT) / 2;
  
  //     /* ================= TITLE ================= */
  
  //     doc.setFont("Inter-Bold", "bold");
  //     doc.setFontSize(8);
  
  //     const title = ellipsize(
  //       doc,
  //       product?.title || "",
  //       LABEL_WIDTH - 3
  //     );
  
  //     doc.text(
  //       title,
  //       rowX + (LABEL_WIDTH - doc.getTextWidth(title)) / 2,
  //       y + TITLE_H - 1
  //     );
  
  //     /* ================= BARCODE ================= */
  
  //     const barcodeY = y + TITLE_H;
  //     const barcodeWidth = LABEL_WIDTH - 20;
  
  //     doc.addImage(
  //       imageData,
  //       "PNG",
  //       rowX + (LABEL_WIDTH - barcodeWidth) / 2,
  //       barcodeY,
  //       barcodeWidth,
  //       BARCODE_H
  //     );
  
  //     /* ================= PRICE LINE ================= */
  
  //     const priceY = barcodeY + BARCODE_H + GAP1;
  //     const rateText = `Rate: ₹ ${salePrice}`;
  //     const mrpText =
  //       mrp && mrp !== salePrice ? `MRP: ₹ ${mrp}` : "";
  
  //     let combinedWidth = mrpText
  //       ? doc.getTextWidth(mrpText) +
  //         2 +
  //         doc.getTextWidth(rateText)
  //       : doc.getTextWidth(rateText);
  
  //     let priceX =
  //       rowX + (LABEL_WIDTH - combinedWidth) / 2;
  
  //     if (mrpText) {
  //       doc.setFont("Inter-Regular", "normal");
  //       doc.setFontSize(6);
  //       doc.text(mrpText, priceX, priceY + 2);
  
  //       const w = doc.getTextWidth(mrpText);
  //       doc.line(priceX, priceY + 1.5, priceX + w, priceY + 1.7);
  //       priceX += w + 2;
  //     }
  
  //     doc.setFont("Inter-Bold", "bold");
  //     doc.setFontSize(8);
  //     doc.text(rateText, priceX, priceY + 2);
  
  //     /* ================= STORE NAME ================= */
  
  //     if (storeName) {
  //       doc.setFont("Inter-Bold", "bold");
  //       doc.setFontSize(4);
  
  //       const storeText = ellipsize(
  //         doc,
  //         storeName,
  //         LABEL_WIDTH - 3
  //       );
  //       const s = doc.getTextWidth(storeName);
  //       doc.text(
  //         storeText,
  //         rowX + (LABEL_WIDTH - s) / 2,
  //         priceY + PRICE_LINE_H + 3
  //       );
  //     }
  //   }
  
  //   return doc;
  // };
  
//single row printed verticaly recommended  but vertical required to fix 
const drawCenteredTwoLineTitle = (doc, text, centerX, startY, maxWidth) => {
  if (!text) return 0;

  const lines = doc.splitTextToSize(text, maxWidth);

  let output;
  if (lines.length <= 2) {
    output = lines;
  } else {
    let second = lines[1];
    while (second.length > 0) {
      second = second.slice(0, -1);
      if (doc.getTextWidth(second + "...") <= maxWidth) break;
    }
    output = [lines[0], second + "..."];
  }

  doc.text(output, centerX, startY, { align: "center" });

  return output.length; //  return number of lines drawn
};

const handlePrintPDF4Lable = () => {
  if (!barcodeValue) {
    setError("Please enter a barcode value before printing.");
    return;
  }
  const canvas = canvasRefs.current.find(c => c);
  if (!canvas) {
    setError("Barcode canvas not ready");
    return;
  }
  
  const imageData = canvas.toDataURL("image/png")
  // const canvas = canvasRefs.current;
  // const imageData = canvas.toDataURL("image/png");

  const salePrice = Number(CurrencyConverter.toCurrency(product?.saleprice,'INR')|| 0);
  const mrp = Number(CurrencyConverter.toCurrency(product?.mrp ,'INR')|| 0);
  const storeName = settings?.saleProfileData?.title || "";

  /* ================= PAGE CONFIG ================= */

  const CONTENT_HEIGHT = 18;

  const PAGE_WIDTH = 100;   // mm
  const PAGE_HEIGHT = 15;   // mm

  const COLS = 4;     

  const LABEL_WIDTH = PAGE_WIDTH / COLS; // 25 mm

  const getLabelX = (col) => col * LABEL_WIDTH;

  const doc = new jsPDF({
    unit: "mm",
    format: [PAGE_HEIGHT,PAGE_WIDTH],
    orientation: "landscape"
  });

  const y = (PAGE_HEIGHT - CONTENT_HEIGHT) / 2;

  /* ================= LABEL DRAWER ================= */
  // const drawLabel = (x) => {
  //   const padding = 1;
  //   const contentY = padding;
  
  //   const centerX = x + LABEL_WIDTH / 2;
  
  //   /* ---------- TITLE ---------- */
  //   doc.setFont("Inter-Bold", "bold");
  //   doc.setFontSize(6);
  
  //   const titleLines = drawCenteredTwoLineTitle(
  //     doc,
  //     product?.title,
  //     centerX,
  //     contentY + 2.8,
  //     LABEL_WIDTH - 2
  //   );
  
  //   /* ---------- BARCODE ---------- */
  //   // const barcodeY = contentY + titleLines * 2.6 + 1.2;
  //   const barcodeY  = contentY;
  //   const barcodeWidth = LABEL_WIDTH - 6;
  
  //   doc.addImage(
  //     imageData,
  //     "PNG",
  //     x + (LABEL_WIDTH - barcodeWidth) / 2,
  //     barcodeY,
  //     barcodeWidth,
  //     5
  //   );
  
  //   /* ---------- BARCODE TEXT ---------- */
  //   doc.setFont("Inter-Regular", "normal");
  //   doc.setFontSize(5);
  
  //   const charSpace = 0.8;
  //   const barcodeTextWidth =
  //     doc.getTextWidth(barcodeValue) +
  //     (barcodeValue.length - 1) * charSpace;
  
  //   doc.text(
  //     barcodeValue,
  //     x + (LABEL_WIDTH - barcodeTextWidth) / 2,
  //     barcodeY + 6.7,
  //     { charSpace }
  //   );
  
  //   /* ---------- PRICE LINE (MRP + RATE) ---------- */
  //   const priceY = barcodeY + 8.7;
  
  //   const rateText = `Rate: ₹ ${salePrice}`;
  //   const mrpText =
  //     mrp && mrp !== salePrice ? `MRP: ₹ ${mrp}` : "";
  
  //   doc.setFontSize(5);
  
  //   const mrpWidth = mrpText ? doc.getTextWidth(mrpText) : 0;
  //   const rateWidth = doc.getTextWidth(rateText);
  //   const gap = mrpText ? 1.2 : 0;
  
  //   const totalWidth = mrpWidth + gap + rateWidth;
  //   let priceX = x + (LABEL_WIDTH - totalWidth) / 2;
  
  //   // MRP
  //   if (mrpText) {
  //     doc.setFont("Inter-Regular", "normal");
  //     doc.text(mrpText, priceX, priceY);
  
  //     // strike-through
  //     doc.line(
  //       priceX,
  //       priceY - 0.6,
  //       priceX + mrpWidth,
  //       priceY - 0.6
  //     );
  
  //     priceX += mrpWidth + gap;
  //   }
  
  //   // RATE
  //   doc.setFont("Inter-Bold", "bold");
  //   doc.text(rateText, priceX, priceY);
  
  //   /* ---------- STORE NAME ---------- */
  //   if (storeName) {
  //     doc.setFont("Inter-Regular", "normal");
  //     doc.setFontSize(4);
  
  //     const storeText = ellipsize(
  //       doc,
  //       storeName,
  //       LABEL_WIDTH - 2
  //     );
  
  //     doc.text(
  //       storeText,
  //       centerX,
  //       priceY + 1.5,
  //       { align: "center" }
  //     );
  //   }
  // };
  
  const ACTUAL_CONTENT_HEIGHT = 13;
  const CONTENT_START_Y = (PAGE_HEIGHT - ACTUAL_CONTENT_HEIGHT) / 2;
  
  const COLUMN_X_OFFSET = {
    0: 1.0,  // first column
    1: 0.0,  // second column
    2: -1.1,  // third column
    3: -2.1   // fourth column
  };
  
  const drawLabel = (x, colIndex) => {
    const offsetX = COLUMN_X_OFFSET[colIndex] ?? 0;
  
    const labelX = x + offsetX; //  calibrated start
    const centerX = labelX + LABEL_WIDTH / 2;
    const contentY = CONTENT_START_Y;
  
    /* ---------- BARCODE ---------- */
    const barcodeY = contentY + 3;
    const barcodeWidth = LABEL_WIDTH - 6;
  
    doc.addImage(
      imageData,
      "PNG",
      labelX + (LABEL_WIDTH - barcodeWidth) / 2,
      barcodeY,
      barcodeWidth,
      6
    );
  
    /* ---------- BARCODE TEXT ---------- */
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(6);
  
    const charSpace = 0.8;
    const barcodeTextWidth =
      doc.getTextWidth(barcodeValue) +
      (barcodeValue.length - 1) * charSpace;
  
    doc.text(
      barcodeValue,
      labelX + (LABEL_WIDTH - barcodeTextWidth) / 2,
      barcodeY + 8.2,
      { charSpace }
    );
  
    /* ---------- PRICE ---------- */
    const priceY = barcodeY + 10;
  
    const rateText = `Rate: ₹ ${salePrice}`;
    const mrpText =
      mrp && mrp !== salePrice ? `MRP: ₹ ${mrp}` : "";
  
    const mrpWidth = mrpText ? doc.getTextWidth(mrpText) : 0;
    const rateWidth = doc.getTextWidth(rateText);
    const gap = mrpText ? 1 : 0;
  
    const totalWidth = mrpWidth + gap + rateWidth;
    // let priceX = labelX + (LABEL_WIDTH - totalWidth) / 2;
    let priceX =labelX + (LABEL_WIDTH - rateWidth) / 2;
    // doc.setFontSize(5);
    // if (mrpText) {
    //   doc.text(mrpText, priceX, priceY);
    //   doc.line(
    //     priceX,
    //     priceY - 0.6,
    //     priceX + mrpWidth-2,
    //     priceY - 0.6
    //   );
    //   priceX += mrpWidth + gap;
    // }
  
    if(toggle){
    doc.setFont("Inter-Bold", "bold");
    doc.text(rateText, priceX, priceY+0.3);}
  };  
  
  const totalLabels = Number(printCount);
  let printed = 0;
  
  while (printed < totalLabels) {
    if (printed !== 0) {
      doc.addPage([PAGE_HEIGHT, PAGE_WIDTH],"landscape");
    }
  
    for (let col = 0; col < 4 && printed < totalLabels; col++) {
      drawLabel(getLabelX(col),col);
      printed++;
    }
  }
  
  return doc;
};
  const handlePrintPDF2 = () => {
    if (!barcodeValue) {
      setError("Please enter a barcode value before printing.");
      return;
    } 
    const canvas = canvasRefs.current.find(c => c);
    if (!canvas) {
      setError("Barcode canvas not ready");
      return;
    }
    
    const imageData = canvas.toDataURL("image/png")
    // const canvas = canvasRefs.current;
    // const imageData = canvas.toDataURL("image/png");
  
    const salePrice = Number(CurrencyConverter.toCurrency(product?.saleprice,'INR')|| 0);
    const mrp = Number(CurrencyConverter.toCurrency(product?.mrp ,'INR')|| 0);
    const storeName = settings?.saleProfileData?.title || "";
  
    /* ================= PAGE CONFIG ================= */
    const PAGE_WIDTH = 101.6;     // mm (2 labels x 50mm)
    const PAGE_HEIGHT = 25;     // mm (single row only)
  
    const LABEL_WIDTH = 50;
    const CONTENT_HEIGHT = 22;
  
    const LEFT_X = -1.5;
    const RIGHT_X = 51+2;
  
    const TITLE_H = 4;
    const BARCODE_H = 7;
    const GAP1 = 1;
    const PRICE_LINE_H = toggle ? 4 : 1.5;
  
    const doc = new jsPDF({
      unit: "mm",
      format: [PAGE_HEIGHT,PAGE_WIDTH],
      orientation: "landscape"
    });
  
    const y = (PAGE_HEIGHT - CONTENT_HEIGHT) / 2;
  
    /* ================= LABEL DRAWER ================= */
    const drawLabel = (rowX) => {
      /* TITLE */
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(7);
      // const title = ellipsize(doc, product?.title || "", LABEL_WIDTH - 4);
      // doc.text(
      //   title,
      //   rowX + (LABEL_WIDTH - doc.getTextWidth(title)) / 2,
      //   y + TITLE_H - 1,
      // );
  
      const labelCenterX = rowX + LABEL_WIDTH / 2;

drawCenteredTwoLineTitle(
  doc,
  product?.title,
  labelCenterX,
  y + TITLE_H - 1,
  LABEL_WIDTH - 4 // padding
);
      /* BARCODE */
      const titleLines = drawCenteredTwoLineTitle(
        doc,
        product?.title,
        labelCenterX,
        y + TITLE_H-1,
        LABEL_WIDTH - 4
      );
      
      const lineHeight = 3; // mm per title line
      const barcodeY = y + titleLines * lineHeight+1;
      
      const barcodeWidth = LABEL_WIDTH - 18;
  
      doc.addImage(
        imageData,
        "PNG",
        rowX + (LABEL_WIDTH - barcodeWidth) / 2,
        barcodeY,
        barcodeWidth,
        BARCODE_H,
        undefined,       // alias
        "FAST"
      );
  
      /* PRICE LINE */
      const priceY = barcodeY + BARCODE_H + GAP1;
      const rateText = `Rate: ₹ ${salePrice}`;
      const mrpText =
        mrp && mrp !== salePrice ? `MRP: ₹ ${mrp}` : "";
  
      let combinedWidth = mrpText
        ? doc.getTextWidth(mrpText) + 2 + doc.getTextWidth(rateText)
        : doc.getTextWidth(rateText);
  
      let priceX = rowX + (LABEL_WIDTH - combinedWidth) / 2;
  
      if (mrpText && toggle) {
        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(6);
        doc.text(mrpText, priceX, priceY + 4.5);
  
        const w = doc.getTextWidth(mrpText);
        doc.line(priceX, priceY + 4, priceX + w, priceY + 4);
        priceX += w + 2;
      }
  if(toggle){
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text(rateText, priceX, priceY + 4.5);
  }
      if (barcodeValue) {
        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(6);
      
        const charSpace = 1.5; // adjust (0.3–1 works well for labels)
      
        // IMPORTANT: width must include char spacing
        const textWidth =
          doc.getTextWidth(barcodeValue) +
          (barcodeValue.length - 1) * charSpace;
      
        doc.text(
          barcodeValue,
          rowX + (LABEL_WIDTH - textWidth) / 2,
          priceY + 1.5,
          { charSpace }
        );
      }
      
      /* STORE NAME */
      if (storeName) {
        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(5.5);
        const storeText = ellipsize(doc, storeName, LABEL_WIDTH - 3);
        const s=doc.getTextWidth(storeText)
        doc.text(storeText, rowX + (LABEL_WIDTH - s) / 2, priceY + PRICE_LINE_H + 3);
      }
    };
  
    /* ================= PAGE LOOP ================= */
    // for (let i = 0; i < Number(printCount); i++) {
    //   if (i !== 0) {
    //     doc.addPage([PAGE_HEIGHT,PAGE_WIDTH],'landscape');
    //   }
  
    //   drawLabel(LEFT_X);
    //   drawLabel(RIGHT_X);
    // }
    const totalLabels = Number(printCount);
    let printed = 0;
    
    while (printed < totalLabels) {
      if (printed !== 0) {
        doc.addPage([PAGE_HEIGHT, PAGE_WIDTH], "landscape");
      }
    
      drawLabel(LEFT_X);
      printed++;
    
      if (printed < totalLabels) {
        drawLabel(RIGHT_X);
        printed++;
      }
    }
    
    return doc;
  };  
  //html version sigle row
//   const handlePrintv4 = async () => {

//     let rows = "";
  
//     const canvas = canvasRef.current;
//     const imageData = canvas.toDataURL("image/png");

//     const salePrice = Number(
//       CurrencyConverter.toCurrency(product?.saleprice, "INR") || 0
//     );
//     const mrp = Number(
//       CurrencyConverter.toCurrency(product?.mrp, "INR") || 0
//     );
  
//     const storeName = settings?.saleProfileData?.title || "";
//     for (let i = 0; i < printCount; i++) {
//       rows += `
//       <div class="row">
//         <!-- LEFT LABEL -->
//         <div class="label">
//           <div class="title">${product?.title}</div>
    
//           <div class="barcode">
//             <img src=${imageData} />
//           </div>
    
//           <div class="price-line">
//           ${mrp && mrp!==salePrice ?(
//             `<div class="mrp">MRP: ₹${mrp}</div>`):""}
//             <div class="rate">Rate: ₹${salePrice}</div>
//           </div>
    
//           <div class="store">${storeName}</div>
//         </div>
    
//         <!-- RIGHT LABEL -->
//         <div class="label">
//           <div class="title">${product?.title}</div>
    
//           <div class="barcode">
//             <img src=${imageData} />
//           </div>
    
//           <div class="price-line">
//           ${mrp && mrp!==salePrice ?(
//             `<div class="mrp">MRP: ₹${mrp}</div>`):""}
//             <div class="rate">Rate: ₹${salePrice}</div>
//           </div>
    
//           <div class="store">${storeName}</div>
//         </div>
//       </div>
//       `;
//     }
  
//     const html = `
//     <!DOCTYPE html>
// <html>
// <head>
// <meta charset="UTF-8" />

// <style>
// /* ===== PAGE SIZE (CRITICAL) ===== */
// @page {
//   size: 107mm 112mm;
//   margin: 0;
// }

// /* ===== ROOT ===== */
// html, body {
//   margin: 0;
//   padding: 0;
//   width: 107mm;
//   height: 112mm;
//   font-family: Inter, Arial, sans-serif;
// }

// /* ===== SHEET ===== */
// .sheet {
//   width: 107mm;
//   height: 112mm;

//   padding-top: 6mm;
//   padding-left: 3mm;
//   padding-right: 3mm;

//   box-sizing: border-box;

//   display: grid;
//   grid-template-columns: repeat(2, 1fr);
//   column-gap: 4mm;
//   row-gap: 3mm;
// }

// /* ===== LABEL ===== */
// .label {
//   width: 48mm;
//   height: 24mm;

//   box-sizing: border-box;
//   text-align: center;
// }

// /* ===== CONTENT ===== */
// .title {
//   font-size: 7.5px;
//   font-weight: bold;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }

// .barcode img {
//   height: 6mm;
//   max-width: 100%;
// }

// .price-line {
//   display: flex;
//   justify-content: center;
//   gap: 1.5mm;
//   font-size: 6px;
// }

// .mrp {
//   text-decoration: line-through;
// }

// .rate {
//   font-size: 7.5px;
//   font-weight: bold;
// }

// .store {
//   font-size: 4px;
//   white-space: nowrap;
//   overflow: hidden;
// }
// </style>
// </head>

// <body>
//   <div class="sheet">
//     ${rows}
//   </div>
// </body>
// </html>

//     `;

// //     try{
// //       const response=await axios.post('http://127.0.0.1:9164/print/html',{
// //        html,
// //        printerName:"SNBC TVSE LP 46 NEO BPLE"
// //       },{
// //        headers: {
// //          'Content-Type': 'application/json'
// //        }
// //      }
// //  )
// //      }catch(error){
// //        handleError(error,showAlert);
// //      }
//      return html;
//   };
 
//   const handlePrintv5 = async () => {
//     if (!barcodeValue) {
//       setError("Please enter a barcode value before printing.");
//       return;
//     }
  
//     const canvas = canvasRef.current;
//     const imageData = canvas.toDataURL("image/png");
  
//     const salePrice = Number(
//       CurrencyConverter.toCurrency(product?.saleprice, "INR") || 0
//     );
//     const mrp = Number(
//       CurrencyConverter.toCurrency(product?.mrp, "INR") || 0
//     );
  
//     const storeName = settings?.saleProfileData?.title || "";
  
//     let labels = "";
  
//     for (let i = 0; i < Number(printCount); i++) {
//       labels += `
//         <div class="label">
//           <div class="title">${product?.title || ""}</div>
  
//           <div class="barcode">
//             <img src="${imageData}" />
//           </div>
  
//           <div class="price-line">
//             ${
//               mrp && mrp !== salePrice
//                 ? `<div class="mrp">MRP: ₹${mrp}</div>`
//                 : ""
//             }
//             <div class="rate">Rate: ₹${salePrice}</div>
//           </div>
  
//           <div class="store">${storeName}</div>
//         </div>
//       `;
//     }
  
//     const html = `
//   <!DOCTYPE html>
//   <html>
//   <head>
//   <meta charset="UTF-8" />
//   <style>
//   /* ================= PAGE ================= */
//   @page { size: 101.6mm auto; margin: 0; }

//   body {
//     width: 101.6mm;
//     margin: 0;
//     font-family: Arial;
//   }
  
//   .sheet {
//     display: grid;
//     grid-template-columns: 50mm 50mm;
//     column-gap: 1.6mm;
//     row-gap: 2mm;
//     padding: 4mm 2mm;
//   }
  
//   .label {
//     width: 50mm;
//     height: 25mm;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//   }

// /* ===== CONTENT ===== */
// .title {
//   font-size: 8px;
//   font-weight: bold;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }

// .barcode img {
//   height: 8mm;
//   max-width: 100%;
// }

// .price-line {
//   display: flex;
//   gap: 2mm;
//   font-size: 7px;
// }

// .rate {
//   font-size: 8px;
//   font-weight: bold;
// }

// .store {
//   font-size: 5px;
//   white-space: nowrap;
//   overflow: hidden;
// }

//   </style>
//   </head>
  
//   <body>
//     <div class="sheet">
//       ${labels}
//     </div>
//   </body>
//   </html>
//   `;

//   // try{
//   //         const response=await axios.post('http://127.0.0.1:9164/print/html',{
//   //          html,
//   //          printerName:"SNBC TVSE LP 46 NEO BPLE"
//   //         },{
//   //          headers: {
//   //            'Content-Type': 'application/json'
//   //          }
//   //        }
//   //    )
//   //        }catch(error){
//   //          handleError(error,showAlert);
//   //        }
  
//     return html;
//   };
  
const handlePrintPDF3 = () => {
  if (!barcodeValue) {
    setError("Please enter a barcode value before printing.");
    return;
  } 
  const canvas = canvasRefs.current.find(c => c);
  if (!canvas) {
    setError("Barcode canvas not ready");
    return;
  }
  
  const imageData = canvas.toDataURL("image/png")
  // const canvas = canvasRefs.current;
  // const imageData = canvas.toDataURL("image/png");

  const salePrice = Number(CurrencyConverter.toCurrency(product?.saleprice,'INR')|| 0);
  const mrp = Number(CurrencyConverter.toCurrency(product?.mrp ,'INR')|| 0);
  const storeName = settings?.saleProfileData?.title || "";

  /* ================= PAGE CONFIG ================= */

// 2 labels in one row
const LABEL_WIDTH = 38;   // each label width
const LABEL_HEIGHT = 25;  // each label height

const PAGE_WIDTH = 80;    // 38mm + 38mm
const PAGE_HEIGHT = 25;

const CONTENT_HEIGHT = 22;

// label positions
const LEFT_X = 1;
const RIGHT_X = 41;

const TITLE_H = 4;
const BARCODE_H = 6; // slightly smaller for 38mm label
const GAP1 = 1;
const PRICE_LINE_H = toggle ? 4 : 1.5;

  const doc = new jsPDF({
    unit: "mm",
    format: [PAGE_HEIGHT,PAGE_WIDTH],
    orientation: "landscape"
  });

  const y = (PAGE_HEIGHT - CONTENT_HEIGHT) / 2;

  /* ================= LABEL DRAWER ================= */
  const drawLabel = (rowX) => {
    /* TITLE */
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(7);
    // const title = ellipsize(doc, product?.title || "", LABEL_WIDTH - 4);
    // doc.text(
    //   title,
    //   rowX + (LABEL_WIDTH - doc.getTextWidth(title)) / 2,
    //   y + TITLE_H - 1,
    // );

    const labelCenterX = rowX + LABEL_WIDTH / 2;

drawCenteredTwoLineTitle(
doc,
product?.title,
labelCenterX,
y + TITLE_H - 1,
LABEL_WIDTH - 4 // padding
);
    /* BARCODE */
    const titleLines = drawCenteredTwoLineTitle(
      doc,
      product?.title,
      labelCenterX,
      y + TITLE_H-1,
      LABEL_WIDTH - 4
    );
    
    const lineHeight = 3; // mm per title line
    const barcodeY = y + titleLines * lineHeight+1;
    
    const barcodeWidth = LABEL_WIDTH - 12;

    doc.addImage(
      imageData,
      "PNG",
      rowX + (LABEL_WIDTH - barcodeWidth) / 2,
      barcodeY,
      barcodeWidth,
      BARCODE_H,
      undefined,       // alias
      "FAST"
    );

    /* PRICE LINE */
    const priceY = barcodeY + BARCODE_H + GAP1;
    const rateText = `Rate: ₹ ${salePrice}`;
    const mrpText =
      mrp && mrp !== salePrice ? `MRP: ₹ ${mrp}` : "";

    let combinedWidth = mrpText
      ? doc.getTextWidth(mrpText) + 2 + doc.getTextWidth(rateText)
      : doc.getTextWidth(rateText);

    let priceX = rowX + (LABEL_WIDTH - combinedWidth) / 2;

    if (mrpText && toggle ) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(7);
      doc.text(mrpText, priceX, priceY + 4.5);

      const w = doc.getTextWidth(mrpText);
      doc.line(priceX, priceY + 4, priceX + w, priceY + 4);
      priceX += w + 2;
    }
    if(toggle){
        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(8);
        doc.text(rateText, priceX, priceY + 4.5);
    }
    if (barcodeValue) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(5);
    
      const charSpace = 1.5; // adjust (0.3–1 works well for labels)
    
      // IMPORTANT: width must include char spacing
      const textWidth =
        doc.getTextWidth(barcodeValue) +
        (barcodeValue.length - 1) * charSpace;
    
      doc.text(
        barcodeValue,
        rowX + (LABEL_WIDTH - textWidth) / 2,
        priceY + 1.5,
        { charSpace }
      );
    }
    
    /* STORE NAME */
    if (storeName) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(6);
      const storeText = ellipsize(doc, storeName, LABEL_WIDTH - 3);
      const s=doc.getTextWidth(storeText)
      doc.text(storeText, rowX + (LABEL_WIDTH - s) / 2, priceY + PRICE_LINE_H + 3);
    }
  };

  /* ================= PAGE LOOP ================= */
  // for (let i = 0; i < Number(printCount); i++) {
  //   if (i !== 0) {
  //     doc.addPage([PAGE_HEIGHT,PAGE_WIDTH],'landscape');
  //   }

  //   drawLabel(LEFT_X);
  //   drawLabel(RIGHT_X);
  // }
  const totalLabels = Number(printCount);
  let printed = 0;
  
  while (printed < totalLabels) {
    if (printed !== 0) {
      doc.addPage([PAGE_HEIGHT, PAGE_WIDTH], "landscape");
    }
  
    drawLabel(LEFT_X);
    printed++;
  
    if (printed < totalLabels) {
      drawLabel(RIGHT_X);
      printed++;
    }
  }
  
  return doc;
};
  
  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  const printPDFInIframe = (doc) => {
    const blob = doc.output("blob");
    const blobUrl = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    iframe.src = blobUrl;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      }, 500);
    };
  };

  // const handlePrints = async () => {
  //   const iframe = document.createElement("iframe");
  //   iframe.style.display = "none";
  //   document.body.appendChild(iframe);
  
  //   const html = await handlePrintv5(); //  await is REQUIRED
  
  //   iframe.contentDocument.open();
  //   iframe.contentDocument.write(html);
  //   iframe.contentDocument.close();
  
  //   iframe.contentWindow.focus();
  //   iframe.contentWindow.print();
  // };
  
  
  const handlePrint = async () => {
    const count = Number(printCount);
  
    // 🔒 Guard: print only if count > 0
    if (!count || count <= 0) {
      setError("Print count must be greater than 0");
      return;
    }
  
    let doc;
  
    if (selectedSize === "2LABEL") {
      doc = handlePrintPDF2();
    }
    else if(selectedSize === "3LABEL") {
      doc =handlePrintPDF3()
    }
    else if (selectedSize === "4LABEL") {
      doc = handlePrintPDF4Lable();
    }
  
    if (!doc) return;
  
    // Optional: if using print service later
    // const pdfBase64 = doc.output("datauristring").split(",")[1];
    // await handlePrintService(pdfBase64, "SNBC TVSE LP 46 NEO BPLE");
  
    printPDFInIframe(doc);
  };
  

  const handleClose = () => {
    if (onClose) onClose();
  };

  useEscapeKey(handleClose);

  return (
    <div className="modal-overlay" style={{zIndex:999}}>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        style={{ display: "block" }}
        role="dialog"
        aria-modal="true"
        tabIndex="-1"
      >
        <div className="modal-dialog  modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Barcode Preview</h6>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body bg-light">
                  <div className="row">
                  <div className="col-7">
                  <div className="card mb-0">
                <div className="card-body"
                 style={{
                  height: "178px",
                  overflowY: "auto",
                }}
                >
                   
                    <div className="row g-0 mt-1"> {/* g-0 removes gutter */}
                      {[...Array(selectedSize==="2LABEL"?2:selectedSize==="3LABEL"?2:4)].map((_, index) => (
                        <div className={`${selectedSize==="2LABEL"?"col-6":selectedSize==="3LABEL"?"col-6":"col-3"} px-0 border rounded-3`} key={index}> {/* px-0 removes padding */}

                          {(selectedSize === "2LABEL" || selectedSize === "3LABEL") && (
                            <div className="text-center fw-bold mt-2 fs-12 product-title">
                              {product?.title}
                            </div>
                          )}

                          <div className={`text-center ${(selectedSize==="2LABEL"|| selectedSize ==="3LABEL")?"mb-0":"mt-3"}`}>
                            <canvas ref={(el) => (canvasRefs.current[index] = el)} 
                            style={{
                              width: (selectedSize === "2LABEL" || selectedSize === "3LABEL") ? "180px" : "90px",
                              height: "40px",
                              display: "block",
                              margin: "0 auto"
                            }}/>
                            {/* <canvas ref={canvasRef} /> */}
                          </div>

                          <div
                            className="text-center fs-12 fw-bold"
                            style={{ letterSpacing:(selectedSize === "2LABEL" || selectedSize === "3LABEL")
                            ? "4px"
                            : "2px", }}
                          >
                              <span>{barcodeValue}</span>   
                           <CopyBarcodeText text={barcodeValue}/>
                          </div>

                          <div className={`d-flex justify-content-center fw-bold fs-12 ${(selectedSize === "2LABEL" || selectedSize==="3LABEL")?"mb-0":"mb-2"} `}>
                            {(selectedSize === "2LABEL" ||selectedSize==="3LABEL") &&
                              product?.mrp &&
                              product.mrp !== product.saleprice && toggle && (
                                <span className="todo-done me-2">
                                  MRP:₹{CurrencyConverter.toCurrency(product.mrp, "INR")}
                                </span>
                              )}
                              {toggle && (
                            <span>
                              Rate:₹{CurrencyConverter.toCurrency(product.saleprice, "INR")}
                            </span>
                            )}
                          </div>

                          {(selectedSize === "2LABEL"||selectedSize==="3LABEL") && (
                            <div className="text-center fs-8 mb-2 fw-bold">
                              {settings?.saleProfileData?.title}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                      </div>
                      </div>
                      </div>
                      <div className="col-5"> 
                      <div className="card mb-0">
                    <div className="card-body">
                      <div className="row g-3 align-items-center">
                        {/* <div className="col-md-4">
                          <label className="form-label mb-0">Barcode Number:</label>
                        </div>
                        <div className="col-md-8">
                          <input
                            type="text"
                            value={barcodeValue}
                            className="form-control"
                            disabled
                          />
                          {error && (
                            <p className="text-danger text-sm mt-1">{error}</p>
                          )}
                        </div>

                        <div className="col-md-4">
                          <label className="form-label mb-0">Fixed Width:</label>
                        </div>
                        <div className="col-md-8">
                          <input
                            type="number"
                            value={barcodeWidth}
                            className="form-control"
                            disabled
                          />
                        </div>

                        <div className="col-md-4">
                          <label className="form-label mb-0">Fixed Height:</label>
                        </div>
                        <div className="col-md-8">
                          <input
                            type="number"
                            value={barcodeHeight}
                            className="form-control"
                            disabled
                          />
                        </div> */}
                        <div className="col-md-4">
                          <label className="form-label mb-0">Label Type:</label>
                        </div>
                        <div className="col-md-8">
                        <select
                          className="form-select"
                          value={selectedSize}
                          onChange={(e) => setSelectedSize(e.target.value)}
                        >
                          {sizeOptions.map((opt) => (
                            <option key={opt.key} value={opt.key}>
                              {opt.label}
                            </option>
                          ))}
                        </select>

                        </div>
                      
                        <div className="col-md-4">
                          <label className="form-label mb-0">Label&nbsp;Count:</label>
                        </div>
                        
                        <div className="col-md-4">
                          <input
                            type="text"
                            value={printCount === null ? "" : printCount}
                            onFocus={(e)=>e.target.select()}
                            onChange={(e) => {
                              const value = e.target.value;
                              setPrintCount(value === "" ? null : Number(value));
                            }}
                            className="form-control"
                          />
                          {error && (
                          <div className="invalid-feedback">
                            {error}
                          </div>
                        )}
                        </div>
                        <div className="col-4"></div>
                        <div className="col-md-4">
                          <label className="form-label mb-0">Price :</label>
                        </div>
                        <div className="col-md-4 d-flex align-items-center">
                        {/* <select
                          className="form-select"
                          value={showMrp ? "on" : "off"}
                          onChange={(e) => setShowMrp(e.target.value === "on")}
                        >
                          <option value="on">On</option>
                          <option value="off">Off</option>
                        </select> */}
                    <label className="custom-toggle cursor-pointer">
                      <input
                        type="checkbox"
                        checked={toggle}
                        onChange={() => setToggle(!toggle)}
                        disabled={loading}
                      />

                      <span className="slider">
                        {loading ? (
                          <span
                            className={`spinner-inside ${
                              toggle ? "spinner-right" : ""
                            }`}
                          />
                        ) : (
                          <>
                            {toggle ? (
                              <span className="label-on ms-0-1">ON</span>
                            ) : (
                              <span className="label-off ms-3">OFF</span>
                            )}
                          </>
                        )}
                      </span>
                    </label>
                      </div>
                      </div>
                      </div>
                      </div>
                    </div>
              </div>
            </div>
            <div className="modal-footer d-block">
            <div className="btn-group text-right align-items-center">
              {/* <button
                type="button"
                className="btn bg-label-animal shadow-none btn-sm dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ borderRight: "2px solid #fff" }}
              /> */}
              <button
                onClick={handlePrint}
                className="btn bg-label-animal shadow-none btn-sm float-end"
              >
                <PrinterIcon iClass={"fs-15"}/> Print Barcode (
                {printCount}x) Labels
              </button>
              {/* <ul className="dropdown-menu dropdown-menu-end">
                          {sizeOptions.map((opt) => (
                            <li key={opt.key}>
                              <button
                                className={`dropdown-item ${
                                  selectedSize === opt.key ? "active" : ""
                                }`}
                                onClick={() => {
                                  setSelectedSize(opt.key);
                                }}
                              >
                                {opt.label}
                              </button>
                            </li>
                          ))}
                        </ul> */}
                        </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarcodeGenerator;
